import { Navigate, Route, Routes } from 'react-router-dom';
import { useSelector } from 'react-redux';

import LicenseListPage from 'pages/LicenseListPage/LicenseListPage';
import NotFoundPage from 'pages/NotFoundPage/NotFoundPage';
import NotSignedInPage from 'pages/NotSignedInPage/NotSignedInPage';
import NotAuthorizedPage from 'pages/NotAuthorizedPage/NotAuthorizedPage';
import IntegrationListPage from 'pages/IntegrationListPage/IntegrationListPage';
import IntegrationEditPage from 'pages/IntegrationEditPage/IntegrationEditPage';
import LicenseEditPage from 'pages/LicenseEditPage/LicenseEditPage';
import CookiePolicyPage from 'pages/CookiePolicyPage/CookiePolicyPage';
import AuthenticationCallback from 'components/AuthenticationCallback/AuthenticationCallback';
import {
    selectCanManageLicenses,
    selectCanManageIntegrations,
} from 'reducers/credentials/selectors';

function Routing(props: RoutingProps) {
    const { isAuthenticated, onAuthorizedEvent } = props;
    const canManageLicenses = useSelector(selectCanManageLicenses);
    const canManageIntegrations = useSelector(selectCanManageIntegrations);

    return (
        <Routes>
            <Route path="/cookie-policy/*" element={<CookiePolicyPage />} />
            {!isAuthenticated && (
                <>
                    <Route path="/" element={<NotSignedInPage />} />
                </>
            )}
            {!(canManageLicenses || canManageIntegrations) && (
                <>
                    <Route path="*" element={<NotAuthorizedPage />} />
                </>
            )}
            {(canManageLicenses || canManageIntegrations) && (
                <>
                    <Route path="/" element={<Navigate to="/integrations" />} />
                    <Route
                        path="/integrations"
                        element={<IntegrationListPage />}
                    />
                    <Route
                        path="/integrations/:integrationId/licenses"
                        element={<LicenseListPage />}
                    />
                </>
            )}
            {isAuthenticated && canManageIntegrations && (
                <>
                    <Route
                        path="/integrations/create-integration"
                        element={<IntegrationEditPage />}
                    />
                    <Route
                        path="/integrations/:integrationId/edit"
                        element={<IntegrationEditPage />}
                    />
                </>
            )}
            {isAuthenticated && canManageLicenses && (
                <>
                    <Route
                        path="/integrations/:integrationId/licenses/create-license"
                        element={<LicenseEditPage />}
                    />
                    <Route
                        path="/integrations/:integrationId/licenses/:licenseId/edit"
                        element={<LicenseEditPage />}
                    />
                </>
            )}
            <Route path="/authentication-callback" element={<AuthenticationCallback />} />

            <Route path="*" element={<NotFoundPage />} />
        </Routes>
    );
}

export default Routing;

type RoutingProps = {
    isAuthenticated: boolean;
    onAuthorizedEvent: () => void;
};
